import { Collapse } from 'bootstrap';

export default class AnchorWithHashListener {
    constructor() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelectorAll("a").forEach(element => {
                element.addEventListener('click', function (event) {
                    // Make sure this.hash has a value before overriding default behavior
                    if (this.hash !== "" && window.location.pathname === this.pathname) {
                        // Prevent default anchor click behavior
                        event.preventDefault();

                        // Store hash
                        let hash = this.hash;

                        let element = document.querySelector(hash);

                        if (element) {
                            if (element.classList.contains('collapse')) {
                                if (!element.classList.contains('show')) {
                                    const collapse = new Collapse(element, {
                                        show: true
                                    })
                                }
                            }
                            setTimeout(function() {
                                element.scrollIntoView({
                                    behavior: 'smooth'
                                });
                            }, 500);
                        }
                    }
                });
            });
        });
    }
}